import React, { memo } from 'react';
import { RouteFC } from 'util/routeTypes';
import { Matryoshka } from '@clover-util/matryoshka';
import { MerchantProvider } from 'hooks/context/merchant';
import { GiftCardCartProvider } from 'hooks/context/giftCardCart';
import { MenuProvider } from 'components/MenuContext/MenuContext';
import { CartProvider } from 'hooks/context/cart';
import { ServiceTypeProvider } from 'hooks/context/serviceType';
import { PersistentQueryParamProvider } from 'hooks/context/PersistentQueryParam';
import { CustomerProvider } from 'hooks/context/customer/customer';
import { MerchantStateProvider } from 'hooks/context/MerchantState';
import { PromptProvider } from 'hooks/context/Prompt';
import { Optimizely } from 'hooks/context/Optimizely';
import { FirstDataQualtircs } from 'components/FirstDataQualtrics';
import { PerksProvider } from 'hooks/context/Perks';
import { DeliveryProvider } from 'hooks/context/Delivery';
import { ReCaptchaProvider } from 'hooks/context/ReCaptcha';
import { ScheduledOrderMethodsProvider } from 'hooks/context/ScheduledOrderMethods';
import { ScheduledOrderDisplayProvider } from 'hooks/context/ScheduledOrderDisplay';
import { DeliveryValidationProvider } from 'hooks/useDeliveryValidation';
import { InvoiceSummaryProvider } from 'routes/Checkout/context/InvoiceSummary';
import { SubmitOrderProvider } from 'routes/Checkout/context/SubmitOrder/SubmitOrder';
import { OrderDetailsProvider } from 'routes/Checkout/context/OrderDetails';
import { ApplePayProvider } from 'components/ApplePay/ApplePay';
import { OrderResponseSummaryProvider } from 'routes/Checkout/context/OrderResponseSummary';
import { CloverPaymentIframeProvider } from 'hooks/context/cloverPaymentIframe';
import { GiftCardProvider } from 'routes/Checkout/context/GiftCard/GiftCardContext';

const wrappers: React.ComponentType[] = [
  CloverPaymentIframeProvider,
  ReCaptchaProvider,
  PersistentQueryParamProvider,
  CustomerProvider,
  ScheduledOrderMethodsProvider,
  DeliveryProvider,
  ServiceTypeProvider,
  ScheduledOrderDisplayProvider,
  DeliveryValidationProvider,
  MenuProvider,
  CartProvider,
  GiftCardCartProvider,
  MerchantStateProvider,
  PerksProvider,
  PromptProvider,
  Optimizely,
  FirstDataQualtircs,
  GiftCardProvider,
  InvoiceSummaryProvider,
  OrderDetailsProvider,
  OrderResponseSummaryProvider,
  ApplePayProvider,
  SubmitOrderProvider,
];

export const Merchant: RouteFC<{merchantId: string}> = memo(function Merchant({ children, merchantId }) {
  return (
    <MerchantProvider merchantId={merchantId}>
      <Matryoshka wrappers={wrappers} children={children} />
    </MerchantProvider>
  );
});
